import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, withKeys as _withKeys } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isTable ? 'table' : 'div'), {
    tabindex: "0",
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowDown(1)), ["exact","prevent"]), ["down"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowUp(1)), ["exact","prevent"]), ["up"])),
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowDown(3)), ["shift","exact","prevent"]), ["down"])),
      _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowUp(3)), ["shift","exact","prevent"]), ["up"])),
      _withKeys(_withModifiers(_ctx.selectCurrent, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(_ctx.onSpaceKeydown, ["exact"]), ["space"])
    ],
    ref: "variable_list_target",
    class: _normalizeClass(['no-outline', { 'var-lst-grid': !_ctx.isTable && _ctx.columns > 1 }]),
    style: _normalizeStyle(!_ctx.isTable && _ctx.columns > 1 ? `--var-lst-columns: ${_ctx.columns};` : '')
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (el, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isTable ? 'tr' : 'div'), {
          key: (_ctx.keyPrefix ? _ctx.keyPrefix : 'varlst_')+(_ctx.keyId ? el['keyPrefix'] : index),
          style: _normalizeStyle(_ctx.isTable ? '' : (_ctx.allowWrap ? '' : 'max-width: 600px;')),
          ref_for: true,
          ref: (el) => { _ctx.divs[index] = el },
          onMouseover: (e) => { _ctx.index_selected = index; _ctx.keyboardNav = false },
          class: _normalizeClass([_ctx.allowWrap ? 'var-lst-item var-lst-item-spaced' : 'q-py-none var-lst-item', { 'var-lst-item--checkbox-mode': _ctx.showCheckbox }, { 'var-lst-subselection': _ctx.index_selected === index && (!_ctx.showCheckbox || _ctx.keyboardNav) }, { 'var-lst-item-selected text-bold text-brown-10': _ctx.elementSelected(index) && !_ctx.showCheckbox }, { 'var-lst-item-disabled': _ctx.isItemDisabled && _ctx.isItemDisabled(el, index) }]),
          onMousedown: (e) => _ctx.onRowMouseDown(index, e),
          onClick: (e) => _ctx.onRowClick(index, e)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(!_ctx.isTable ? (_ctx.allowWrap ? 'row items-start var-lst-wrap' : 'row no-wrap') : ''),
              style: _normalizeStyle(_ctx.isTable ? 'display: contents;' : '')
            }, [
              (_ctx.showCheckbox && !_ctx.isTable)
                ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                    key: 0,
                    class: _normalizeClass(['rec-checkbox', { 'unset-items-center': !_ctx.allowWrap }]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                    "model-value": _ctx.elementSelected(index),
                    "onUpdate:modelValue": ($event: any) => (_ctx.selectElement(index))
                  }, null, 8, ["class", "model-value", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.allowWrap)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(['var-lst-slot-wrap', { 'var-lst-slot-wrap--contents': _ctx.slotWrapDisplayContents }])
                  }, [
                    _renderSlot(_ctx.$slots, "default", { item: el })
                  ], 2))
                : _renderSlot(_ctx.$slots, "default", {
                    key: 2,
                    item: el
                  })
            ], 6)
          ]),
          _: 2
        }, 1064, ["style", "onMouseover", "class", "onMousedown", "onClick"]))
      }), 128))
    ]),
    _: 3
  }, 40, ["onKeydown", "class", "style"]))
}